export function isInvalid(value: any, expectedType: string): boolean {
    if (value === undefined || value === null) return true;
    if (expectedType === 'number' && (Number.isNaN(value) || value === 'NaN' || Number.isNaN(Number(value)))) return true;
    if (expectedType === 'object' && Object.keys(value).length === 0) return true;
    if (expectedType === 'string' && value === '') return true;
    if (typeof value !== expectedType) return true;
    return false;
}